import { Text } from '@fable/components'
import { css, useTheme } from '@fable/theme'
import { useClub } from 'app/clubs/hooks'
import { ClubDetailModerators } from './ClubDetailModerators'

export const ClubDetailAbout = () => {
  const { colors, mediaQueries } = useTheme()
  const club = useClub()

  return (
    <div>
      <ClubDetailModerators club={club} />
      <Text
        className={css`
          margin-top: 12px;
          ${mediaQueries.tabletL} {
            margin-top: 18px;
          }
        `}
        type="body"
        sizing={{ base: 'M', tabletL: 'L' }}
        color={`${colors.graphite}cc`}
      >
        {club?.feature_text || club?.about_us}
      </Text>
    </div>
  )
}
